import Vue from 'vue';
import formDialog from '@/components/webManage/formDialog.vue';
import dialogtitle from '@/components/crm/crm-dialog-title.vue';
import template from '!!raw-loader!./template.html';
const { render } = Vue.compile(template);

export default function ({
  name,
  onInit,
  onShowLoad,
  componentForm,
}) {
  return {
		name,
		components: {
			formDialog,
			dialogtitle,
			componentForm,
		},
		props: ['title', 'subTitle'],
		data() {
			let data = onInit ? onInit(this) : {};
			return {
				...data,
				loading: false,
				currentData: null,
				visable: false,
			};
		},
		methods: {
			onOK(props) {
				this.callback &&
					this.callback({
						...props,
						cancel: false,
					});
				this.visable = false;
			},
			onCancel(props) {
				this.callback &&
					this.callback({
						...props,
						cancel: true,
					});
				this.visable = false;
			},
			async show(props) {
				const self = this;
				self.loading = true;
				if (onShowLoad) {
					const currentData = await onShowLoad(props, self);
					self.currentData = currentData;
				}
				self.loading = false;
				self.visable = true;
				return new Promise(reslove => {
					self.callback = reslove;
				});
			},
		},
		render,
	};
}
